<template>
  <div
    class="lt-section tw-relative tw-w-full tw-h-screen tw-bg-top-section tw-bg-no-repeat tw-bg-cover tw-overflow-hidden tw-snap-start tw-flex tw-justify-end tw-items-center"
  >
    <img
      v-if="mobile"
      class="woman-center tw-absolute tw-bottom-9 tw-m-auto tw-max-w-screen-lg inset-horizontal-center tw-z-10"
      :src="`${imgPath}/animation-3-mobile.png`"
    />
    <div class="tw-relative tw-w-full tw-h-full tw-flex tw-justify-end">
      <img
        v-if="!mobile"
        class="woman-center tw-max-w-95 tw-invisible tw-z-10 tw-bottom-0 tw-left-0 tw-right-0 tw-m-auto 2xl:tw-w-10/12 xl:tw-w-full md:tw-w-full md:tw-max-w-screen-2xl 2xl:tw-transform 2xl:tw-scale-125"
        :src="`${imgPath}/animation-3.png`"
      />
      <img
        v-if="!mobile"
        class="blue-fire tw-absolute tw-w-2/5 tw-h-auto tw-m-auto tw-invisible tw-top-1.5/10 tw-z-10 md:tw-w-1/5 2xl:tw--top-1/10 2xl:tw-left-2.7/10 lg:tw--top-0 lg:tw-left-2/10"
        :src="`${imgPath}/animationeffect-1.png`"
      />
      <img
        v-if="!mobile"
        class="red-fire tw-absolute tw-w-2/4 tw-h-auto tw-invisible tw-top-1.5/10 tw--right-1/10 tw-z-10 md:tw-w-1/4 2xl:tw--top-0.3/10 2xl:tw-right-2.2/10 lg:tw-top-0 lg:tw-right-2/10"
        :src="`${imgPath}/animationeffect-2.png`"
      />
    </div>

    <img
      class="man-left tw-absolute tw-h-auto tw-m-auto tw-invisible tw-left-0 tw-top-0 tw-max-w-md 2xl:tw-w-2/5 2xl:tw-top-1.5/10 lg:tw-w-4/12 lg:tw-top-3/10 md:tw-w-1/12 md:tw-left-0.2/10 md:tw-top-1/10 md:tw-max-w-full md:tw-z-20"
      :src="`${imgPath}/animation-2.png`"
    />
    <img
      class="woman-right tw-m-auto tw-invisible tw-absolute tw--right-4/10 tw--top-0 md:tw-z-20 2xl:tw-w-1/3 2xl:tw--bottom-0.8/10 2xl:tw--right-0.3/10 lg:tw-w-2/5 lg:tw--bottom-0.8/10 lg:tw--right-1/10 tw-opacity-60 md:tw-top-auto md:tw-opacity-100"
      :src="`${imgPath}/animation-4.png`"
    />
    <img
      class="monster-bottom tw-absolute tw-w-2/12 tw-m-auto tw-z-20 tw-invisible tw-bottom-0.3/10 tw-left-1/10 tw-hidden md:tw-block"
      :src="`${imgPath}/animation-6.png`"
    />
    <img
      class="monster-top tw-absolute tw-w-3/12 tw-h-auto tw-m-auto tw-invisible tw-right-0 tw-top-0 tw-hidden md:tw-block "
      :src="`${imgPath}/animation-1.png`"
    />

    <img
      class="woman-bottom-center tw-absolute tw-max-w-90 tw-h-auto tw-m-auto tw-z-10 tw-invisible inset-custom-horizontal tw--bottom-0.6/10 md:tw-left-0 md:tw--right-0.7/10 2xl:tw-w-4/5 xl:tw-w-full md:tw-max-w-full md:tw-transform-none"
      :src="`${imgPath}/animation-5.png`"
    />
    <img
      class="zisk-banner tw-w-full tw-absolute tw-h-auto tw-m-auto tw-z-30 tw-invisible tw-bottom-2/10 tw-left-0 tw-right-0 2xl:tw-w-2/5 xl:tw-w-3/5 lg:tw-w-3/5 md:tw-w-2/5 md:tw-bottom-1.1/10"
      :src="`${imgPath}/animation-title.png`"
    />
    <img
      class="effect-1 tw-absolute tw-w-1/3 tw-h-auto tw-m-auto tw-z-30 tw-left-0.2/10 tw-hidden md:tw-block 2xl:tw-top-1/10 xl lg:tw-top-2.2/10 lg:tw-w-1/4 tw-invisible"
      :src="`${imgPath}/animationeffect-3.png`"
    />
  </div>
</template>

<script>
import { gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
gsap.registerPlugin(CSSPlugin);

export default {
  name: "top-section",
  props: {
    mobile: Boolean,
    wWidth: Number
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL
    };
  },
  methods: {
    initAnimation: function() {
      const first = gsap.timeline();
      const second = gsap.timeline();
      const third = gsap.timeline();
      const fourth = gsap.timeline();
      const fifth = gsap.timeline();

      first.set(".woman-center", { visibility: "visible" });
      second.set(".woman-right", { visibility: "visible" });
      second.set(".man-left", { visibility: "visible" });
      second.set(".woman-bottom-center", { visibility: "visible" });
      third.set(".monster-top", { visibility: "visible" });
      third.set(".monster-bottom", { visibility: "visible" });
      fourth.set(".zisk-banner", { visibility: "visible" });
      fifth.set(".effect-1", { visibility: "visible" });
      fifth.set(".blue-fire", { visibility: "visible" });
      fifth.set(".red-fire", { visibility: "visible" });
      //console.log(this.wWidth);
      if (this.wWidth > 1366 && !this.mobile) {
        first.fromTo(
          ".woman-center",
          { opacity: 0 },
          { opacity: 1, duration: 0.5 },
          1
        );
        second.fromTo(
          ".man-left",
          { opacity: 0, top: "30%", left: "30%" },
          {
            opacity: 1,
            top: "15%",
            left: "2%",
            duration: 0.5,
            ease: "power3.inOut"
          },
          1.4
        );
        second.fromTo(
          ".woman-right",
          { opacity: 0, bottom: "-100%", right: "-3%" },
          {
            opacity: 1,
            bottom: "-8%",
            right: "-3%",
            duration: 0.5,
            ease: "power3.inOut"
          },
          1.4
        );
        second.fromTo(
          ".woman-bottom-center",
          { opacity: 0, bottom: "-10%", left: "0", right: "-7%" },
          {
            opacity: 1,
            bottom: "-6%",
            left: "0",
            right: "-7%",
            duration: 0.5,
            ease: "power3.inOut"
          },
          1.4
        );
        third.fromTo(
          ".monster-top",
          { opacity: 0, right: "-15%", top: "20%" },
          {
            opacity: 1,
            right: "0",
            top: "0",
            duration: 0.5,
            ease: "power3.in"
          },
          1.7
        );
        third.fromTo(
          ".monster-bottom",
          { opacity: 0, bottom: "10%", left: 0 },
          {
            opacity: 1,
            bottom: "3%",
            left: "10%",
            duration: 0.5,
            ease: "power3.in"
          },
          1.7
        );
        fourth.fromTo(
          ".zisk-banner",
          { opacity: 0, bottom: 0, left: 0, right: 0 },
          {
            opacity: 1,
            bottom: "11%",
            left: 0,
            right: 0,
            duration: 0.5,
            ease: "power3.in"
          },
          1.7
        );
        fifth.fromTo(
          ".effect-1",
          { opacity: 0, scaleY: 0 },
          { opacity: 1, scaleY: 1, duration: 0.5 },
          2.3
        );
        fifth.fromTo(
          ".red-fire",
          { opacity: 0, scaleY: 0 },
          { opacity: 1, scaleY: 1, duration: 0.5 },
          2.3
        );
        fifth.fromTo(
          ".blue-fire",
          { opacity: 0, scaleY: 0 },
          { opacity: 1, scaleY: 1, duration: 0.5 },
          2.3
        );
        fifth.fromTo(
          ".red-fire",
          { opacity: 1 },
          {
            opacity: 0.8,
            scaleY: 0.95,
            skewX: -1,
            skewY: 1,
            translateY: 2,
            repeat: -1,
            yoyo: true,
            duration: 1.6
          },
          3
        );
        fifth.fromTo(
          ".blue-fire",
          { opacity: 1 },
          {
            opacity: 0.8,
            scaleY: 0.95,
            skewX: 1,
            skewY: -2,
            translateY: 2,
            repeat: -1,
            yoyo: true,
            duration: 1.6
          },
          3
        );
      }
    }
  },
  created: function() {
    window.addEventListener("load", this.initAnimation);
  }
};
</script>
